
import { Box, Tab, Tabs } from "@mui/material";
import Logs from "../../shared/datamanagementcomponents/log";
import ItsoOutputTables from "../itso/childcomponents/itsooutputtables";
import ItsoTables from "../itso/childcomponents/itsotables";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../stores/hooks";
import { setcurrentmenu } from "../../stores/menuslice";
import { TabPanel,a11yProps,TabPanelProps } from "../../shared/childcomponents/TabPanels";
import MenuConfig from "./childcomponents/menuconfig";
import DataTableConfig from "./childcomponents/datatableconfig";
import OutputTableConfig from "./childcomponents/outputtableconfig";

export default function Configuration(){
    const [value, setValue] = useState(0);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setcurrentmenu('configuration'));
  },[] )

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
    return(
        <Box sx={{ width: '100%',p:1,bgcolor:'inherit' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} variant="fullWidth" aria-label="basic tabs example">
          <Tab label="Menu" {...a11yProps(0)} />
          <Tab label="Data Tables" {...a11yProps(1)} />
          <Tab label="Output Tables" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <MenuConfig/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DataTableConfig/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OutputTableConfig/>
      </TabPanel>
        </Box>
    )
}